var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('img',{staticClass:"inline-block mb-4",attrs:{"src":require("@/assets/images/ai-no-result.svg")}}),_c('p',[_vm._v(_vm._s(_vm.$i18nPresenter.t("Looks like our robot's stumped!")))]),_c('p',[_vm._v(_vm._s(_vm.$i18nPresenter.t('Try rephrasing or providing more details.')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }